<template>
    <page-preloader v-if="promotionStatus === 'loading'"></page-preloader>
    <div v-else-if="!promotion" class="main v-promo">
        <div class="container">
            <bread-crumbs
                :default-url="previousRoute.name"
                :text="previousRoute.routeText"
                :force-default-url="previousRoute.name === 'add-new-promo'"
            />
        </div>
        <div>
            <p class="h5 -center" v-text="'Promocja nie została odnaleziona'" />
        </div>
    </div>
    <main v-else-if="promotion" class="main v-promo" id="single-promo">
        <div class="container">
            <bread-crumbs
                :default-url="previousRoute.name"
                :text="previousRoute.routeText"
                :force-default-url="previousRoute.name === 'add-new-promo'"
            />

            <promotion-header
                :promotion="promotion"
                :product-sets="sortedProductSets"
            />

            <div class="a-infoBar a-infoBar--warning mt-5">
                Decyzja o cenie w Promocji należy do Ciebie, aktywuj
                wybraną promocję i edytuj jej cenę w oknie aktywacji.
                Tylko cena ustalona przez Ciebie na poziomie nie wyższym
                niż zaproponowana uprawnia do otrzymania Zwrotu Kosztów.
            </div>

            <promotion-details
                class="mt-5"
                :promotion="promotion"
                :allow-deselect-all="allowDeselectAll"
                :accept-promos="acceptPromos"
                :deselect-all="deselectAll"
                :is-locked="isLocked"
            />

            <section class="m-promotionProductsTable mt-5">
                <template v-if="promoProducts && promoProducts.length">
                    <h2 class="h5 font-weight-medium mb-3">
                        Produkty promocyjne
                        <span v-if="productsPagination">
                            ({{
                                Number(promotion.totalProductsRecords) ||
                                +productsPagination.totalRecords
                                    | plurals(
                                        'produkt',
                                        'produkty',
                                        'produktów'
                                    )
                            }})
                        </span>
                    </h2>
                    <div id="products" class="product-list">
                        <div class="c-table tableFlexx">
                            <div
                                v-sticky-elem="{
                                    background: 'var(--color-gray-100)'
                                }"
                                class="c-thead"
                            >
                                <div class="c-tw w-names">
                                    <div class="c-td c-promos-image"></div>
                                    <div class="c-td">Produkty</div>
                                </div>
                                <div v-if="type !== PROMO_TYPES.SALES_TARGET" class="c-tw w-numbers">
                                    <div class="c-td">Zwrot netto</div>
                                    <div
                                        v-if="
                                            type !==
                                                'Promo::WeightPeriodicPriceReduction' &&
                                            type !== 'Promo::WeightRegularPrice'
                                        "
                                        class="c-td"
                                    >
                                        Min. liczba
                                    </div>
                                    <!-- Cena hurtowa (max. marża) ECD-->
                                    <div
                                        v-if="
                                            type !== PROMO_TYPES.QUOTA &&
                                            type !==
                                                PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
                                        "
                                        class="c-td"
                                    >
                                        Max cena hurt. ECD
                                        <div class="d-flex align-items-center">
                                            (marża %)
                                            <a-icon
                                                icon="Info"
                                                width="1rem"
                                                height="1rem"
                                                class="text-dark ml-1"
                                                v-tooltip="wholesalePriceMarginTooltip('ECD')"
                                            ></a-icon>
                                        </div>
                                    </div>
                                    <!-- Cena hurtowa (max. marża) ECC-->
                                    <div
                                        v-if="
                                            type !== PROMO_TYPES.QUOTA &&
                                            type !==
                                                PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
                                        "
                                        class="c-td"
                                    >
                                        Max cena hurt. ECC
                                        <div class="d-flex align-items-center">
                                            (marża %)
                                            <a-icon
                                                icon="Info"
                                                width="1rem"
                                                height="1rem"
                                                class="text-dark ml-1"
                                                v-tooltip="wholesalePriceMarginTooltip('ECC')"
                                            ></a-icon>
                                        </div>
                                    </div>
                                    <!-- Cena hurtowa (max. marża) DZ-->
                                    <div
                                        v-if="
                                            type !== PROMO_TYPES.QUOTA &&
                                            type !==
                                                PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
                                        "
                                        class="c-td"
                                    >
                                        Max cena hurt. DZ
                                        <div class="d-flex align-items-center">
                                            (marża %)
                                            <a-icon
                                                icon="Info"
                                                width="1rem"
                                                height="1rem"
                                                class="text-dark ml-1"
                                                v-tooltip="wholesalePriceMarginTooltip('DZ')"
                                            ></a-icon>
                                        </div>
                                    </div>
                                    <div
                                        v-if="type === PROMO_TYPES.QUOTA"
                                        class="c-td"
                                    >
                                        Rabat brutto
                                    </div>
                                    <div
                                        class="c-td"
                                        v-else-if="products.length > 0"
                                    >
                                        Max. cena
                                    </div>
                                </div>
                            </div>
                            <page-preloader
                                mode="wrapper"
                                :is-loading="
                                    $store.getters.getPromoProductsStatus ===
                                    'loading'
                                "
                            >
                                <div class="c-tbody">
                                    <template v-if="products.length > 0">
                                        <product-tree
                                            :products="products"
                                            component-name="PromoProduct"
                                            fetching-method-name="loadPromoProducts"
                                            :promotion="promotion"
                                            :root-margin="-305"
                                        />
                                    </template>
                                </div>
                            </page-preloader>
                            <div class="c-tfooter">
                                <results-dropdown
                                    v-if="productsPagination"
                                    :per-page="+productsPagination.perPage"
                                    :options="[10, 20, 50, 100]"
                                    :on-change="changeResultsPerPage"
                                />
                                <the-pagination-small
                                    :page="productsPagination.page"
                                    :getter="
                                        $store.getters
                                            .getPromoProductsPagination
                                    "
                                    setter="loadPromoProducts"
                                    loader="getPromoProductsStatus"
                                />
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="isBonded">
                    <div
                        class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mb-3"
                    >
                        {{ promoBondedDescription }}
                    </div>
                </template>

                <template
                    v-if="sortedProductSets && sortedProductSets.length > 0"
                >
                    <div
                        class="product-set"
                        v-for="(productSet, idx) in sortedProductSets"
                        :key="idx"
                    >
                        <products-set-preview
                            :promotion="promotion"
                            :product-set="productSet"
                            :index="idx"
                        />
                    </div>
                </template>
            </section>

            <section class="mt-5">
                <h2 class="h5 font-weight-medium mb-3">
                    Status promocji w sklepach
                </h2>

                <div
                    class="form-group input-with-icon promo-details-search mb-2"
                >
                    <search-input
                        class="mb-2"
                        name="Search"
                        :search-input="searchInput"
                        :search-params-tooltip="['nazwie sklepu', 'adresie']"
                        @change="searchInput = $event"
                    />
                </div>
                <div class="shops-list">
                    <div class="c-table">
                        <div class="c-thead">
                            <div class="c-td w-name">Nazwa i adres sklepu</div>
                            <div class="c-tw w-middle">
                                <div class="c-tw w-stats">
                                    <div class="c-td --last-change">
                                        Ostatnia zmiana
                                    </div>
                                    <div class="c-td --status-promo">
                                        Status promocji
                                    </div>
                                    <div v-if="type === PROMO_TYPES.SALES_TARGET" class="c-td --promo-limit d-flex align-items-center">
                                        Liczba użyć / Max. próg
                                        <a-icon
                                            v-tooltip="'Poziom realizacji celu sprzedażowego'"
                                            icon="Info" width="1rem" class="ml-1"
                                        />
                                    </div>
                                    <div v-else class="c-td --promo-limit d-flex align-items-center">
                                        Liczba użyć / limit
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="isPromoEditPermission"
                                class="c-td w-actions"
                            >
                                <div
                                    v-if="isSelectAllSubsDataCheckbox"
                                    class="form-check form-check-inline"
                                >
                                    <div>
                                        <ui-checkbox-input
                                            class="c-thead"
                                            name="selectAllSubsData"
                                            v-model="selectAllSubsData"
                                            label="Aktywuj promocje"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="c-tbody">
                            <subscription-preview
                                v-for="subscription in searchedSubs"
                                :key="subscription.id"
                                :data="subscription"
                                :promotion="promotion"
                                :promo-type="promotion.type"
                                :select-group="selectPromoGroupPromo"
                                :is-locked="isLocked"
                                @changeAllowDeselectAll="deselectAll"
                            ></subscription-preview>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div
            v-if="selectedSubscriptionsLength > 0"
            class="selected"
            data-selected-bar
            style="position: sticky; bottom: 0px"
        >
            <div class="selected-header">
                <div class="container selected-header-content">
                    <span class="selected-heading">
                        Wybrano:
                        <span>{{
                            selectedSubscriptionsLength
                                | plurals('sklep', 'sklepy', 'sklepów')
                        }}</span>
                    </span>
                    <div>
                        <the-btn
                            btn-class="btn btn-secondary"
                            text="Aktywuj w wybranych sklepach"
                            icon="Promotions"
                            @click.native="onClickAcceptSubScriptions"
                        ></the-btn>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import ProductsSetPreview from '@/components/promotions/ProductsSetPreview.vue'
import SubscriptionPreview from '@/components/promotions/SubscriptionPreview.vue'
import PromotionHeader from '@/components/promotion/Header.vue'
import PromotionDetails from '@/components/promotion/Details.vue'
import { setTableFlex } from '@/mixins/setTableFlex'
import promoBonded from '@/mixins/promoBonded'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    mixins: [setTableFlex, promoBonded],
    data() {
        return {
            allowDeselectAll: true
        }
    },
    components: {
        SubscriptionPreview,
        ProductsSetPreview,
        PromotionHeader,
        PromotionDetails
    },
    computed: {
        productsPagination() {
            return this.$store.getters.getPromoProductsPagination
        },

        promoGroup() {
            const group = this.$store.getters.getPromoGroups[0]
            return {
                ...group,
                selectedPromoIds: [this.promotion.id]
            }
        },

        promoProducts() {
            return this.$store.getters.getPromoProducts
        },

        sortedProductSets() {
            let sets = this.$store.getters.getPromoProductSets

            // sort sets - promotional sets last
            if (sets) {
                sets = sets.sort((a, b) =>
                    a.type === 'ProductSet::Promotional'
                        ? 1
                        : b.type === 'ProductSet::Promotional'
                            ? -1
                            : 0
                )
            }
            return sets
        },

        promotion() {
            return (
                this.$store.getters.getPromoGroups &&
                this.$store.getters.getPromoGroups[0]?.promos[0]
            )
        },

        products() {
            let products = []
            if (this.promoProducts?.length) {
                products = this.promoProducts
            }
            return products
        },

        promotionStatus() {
            return this.$store.getters.getPromotionStatus
        },

        merchants() {
            return this.$store.getters.getMerchants
        },

        selectAllSubsData: {
            get() {
                return this.$store.getters
                    .getSelectedPromoGroupPromoItem({
                        promoId: this.promotion.id,
                        groupId: this.promotion.groupId
                    })
                    ?.subscriptions?.filter((sub) => sub.state === 'available')
                    .every((sub) => sub.checked === true)
            },
            async set(value) {
                await this.deselectAll()
                await this.selectPromoGroupPromo()
                this.$store.dispatch('selectAllMerchants', {
                    promoId: this.promotion.id,
                    shops: this.promotion.subscriptions
                        ?.filter((el) => el.state === 'available')
                        .map((el) => el.merchant_id),
                    value: value,
                    promotion: this.promotion,
                    fromPromoDetails: true
                })
            }
        },

        searchInput: {
            get() {
                return this.$store.getters.getMerchantSearch
            },
            set(value) {
                this.$store.dispatch('searchMerchants', value)
            }
        },

        searchedSubs() {
            // return shop list
            let merchants = this.merchants

            merchants = merchants
                .filter((item) => {
                    const searchLower = this.searchInput.toLowerCase()
                    return item.name.toLowerCase().includes(searchLower) ||
                        this.$store.getters.getShopAddress(item).toLowerCase().includes(searchLower)
                })
                .map((item) => item.id)

            return this.promotion.subscriptions?.filter((shop) => {
                return merchants.includes(shop.merchant_id)
            })
        },

        selectedSubscriptionsLength() {
            return this.$store.getters.getSelectedSubscriptionsByPromoId(
                this.promotion.id,
                this.promotion.groupId
            )
        },

        promoBondedDescription() {
            const setTrigger = this.sortedProductSets?.find(
                (set) => set.type === 'ProductSet::Trigger'
            )
            const setPromotional = this.sortedProductSets?.find(
                (set) => set.type === 'ProductSet::Promotional'
            )

            const { currency, plurals } = this.$options.filters

            const areAny = (number) =>
                plurals(
                    +number,
                    'znajduje się dowolna',
                    'znajdują się dowolne',
                    'znajduje się dowolnych',
                    undefined,
                    undefined,
                    true
                )

            const firstSentence = `Jeśli na paragonie ${areAny(
                setTrigger.required_weight
            )} ${+setTrigger.required_weight} szt. z listy produktów wywołujących promocję, kupujący może nabyć dodatkowo `

            let secondSentence = ''
            if (this.promotion.type === PROMO_TYPES.BONDED) {
                secondSentence = `${plurals(
                    +setPromotional.required_weight,
                    'szt. wybranego produktu',
                    'szt. wybranych produktów'
                )} z listy za cenę ${currency(setPromotional.price)}.`
            }

            if (this.promotion.type === PROMO_TYPES.BONDED_QUOTA) {
                secondSentence = `${plurals(
                    +setPromotional.required_weight,
                    'szt. wybranego produktu',
                    'szt. wybranych produktów'
                )} z listy z łącznym rabatem ${currency(
                    +setPromotional.required_weight *
                        setPromotional.discount_amount
                )} (-${currency(setPromotional.discount_amount)} / szt.).`
            }

            if (this.promotion.type === PROMO_TYPES.BONDED_PERCENTAGE) {
                secondSentence = `${plurals(
                    +setPromotional.required_weight,
                    'szt. wybranego produktu',
                    'szt. wybranych produktów'
                )} z listy rabatowanych ze zniżką ${
                    setPromotional.discount_percentage
                }%.`
            }

            return firstSentence + secondSentence
        },

        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },

        previousRoute() {
            const previousRoute = this.$router.options.previous?.name

            if (!previousRoute) {
                // If user opens app in new tab
                return {
                    routeText: 'Przejdź do listy wszystkich promocji',
                    name: 'promo-list'
                }
            }

            const fromLabels = previousRoute.name === 'labels'

            return {
                routeText: fromLabels
                    ? 'Wróć do listy wszystkich cenówek'
                    : 'Wróć do listy wszystkich promocji',
                name: previousRoute.name
            }
        },

        isLocked() {
            const lockedAt = this.promotion.locked_at
            if (!lockedAt) {
                return false
            }

            const today = this.$moment()

            return this.$moment(lockedAt).isBefore(today)
        },

        type() {
            return this.promotion.type
        },

        isSelectAllSubsDataCheckbox() {
            const hasAvailableSubscriptions = this.promotion.subscriptions.some(
                (el) => el.state === 'available' && !el.suspended
            )

            return !this.isLocked && hasAvailableSubscriptions && !this.promoGroup.loadingSelectedPromoIds
        }
    },
    async created() {
        this.allowDeselectAll = true
        this.loadPromo()
        window.scrollTo(0, 0)

        window.addEventListener('scroll', () => {
            this.setTableHeaderFlex()
        })
        window.addEventListener('resize', () => {
            this.setTableHeaderFlex()
        })
        this.$store.dispatch('fetchRetailersCompanies')
        this.$store.dispatch('fetchPromotionsLimits', {
            promoId: this.$route.params.id
        })
        if (!this.$store.getters.getFavoritesInitLoad) {
            this.$store.dispatch('loadFavoritePromos')
            this.$store.commit('SET_FAVORITES_INIT_LOAD', true)
        }

        this.PROMO_TYPES = PROMO_TYPES
    },
    beforeDestroy() {
        this.$store.dispatch('clearSelectedPromoGroups')
        this.$store.dispatch('clearPromoProducts')
        this.$store.dispatch('setSelectAllMerchants', false)
    },
    methods: {
        async loadPromo() {
            await this.$store.dispatch('loadPromotion', {
                promoId: this.$route.params.id,
                includes: 'infographic,company,logo,company.logo,terms'
            })
        },

        loadProductsPage(page) {
            this.$store.dispatch('loadPromoProducts', {
                per: this.$store.getters.getPromoProductsPerPage,
                page
            })
        },

        acceptPromos(singleSubscription = false) {
            if (this.$store.getters.isLotteryUser) {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else {
                this.$store.dispatch('openModal', {
                    component: 'ModalPromoAccept',
                    classes: 'modal--accept',
                    args: {
                        singleSubscription: singleSubscription,
                        promoId: this.promotion.id
                    }
                })
            }
        },

        onClickAcceptSubScriptions() {
            if (this.promoGroup.acceptance === 'any') {
                this.acceptPromos(true)
            } else {
                const confirm = {
                    message: `Promocja należy do grupy zamkniętej. Aktywowanie tej promocji będzie skutkowało aktywowaniem całej grupy <strong>${this.promoGroup.name}</strong>. Czy chcesz aktywować? `,
                    header: `Aktywowanie promocji <h3 class="h5 px-2 pt-2">${this.promotion.name}</h3>`,
                    abortButtonText: 'Wróć',
                    confirmButtonText: 'Potwierdzam',
                    abortButtonCallback: () => {
                        this.$store.dispatch('toggleModal', false)
                    },
                    confirmButtonCallback: () => {
                        this.acceptPromos(true)
                    }
                }
                this.$store.dispatch('openConfirmationWindow', confirm)
            }
        },

        deselectAll() {
            if (!this.allowDeselectAll) {
                return
            }
            this.allowDeselectAll = false
            this.$store.dispatch('clearSelectedPromoGroups')
        },

        changeResultsPerPage(val) {
            this.$store.commit('SET_PROMO_PRODUCTS_PER_PAGE', val)

            this.$store.dispatch('loadPromoProducts', {
                per: this.$store.getters.getPromoProductsPerPage,
                page: 1
            })
        },

        selectPromoGroupPromo(params) {
            return this.$store.dispatch('selectPromoGroupPromo', {
                promoId: this.promotion.id,
                groupId: this.promotion.groupId,
                select: true,
                acceptance: this.promoGroup.acceptance,
                addPromoWholeGroup: true,
                fromPromoDetails: true,
                params
            })
        },
        wholesalePriceMarginTooltip(code) {
            return this.$store.getters.getWholesalePriceMarginTooltip(code)
        }
    }
}
</script>

<style lang="scss" scoped>
.c-thead {
    background-color: var(--color-white);

    &.sticky-elem {
        border-top: 1px solid var(--tr-border);
        border-left: 1px solid var(--tr-border);
        border-right: 1px solid var(--tr-border);

        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        margin-left: -1px;
        margin-right: -1px;

        &:before {
            left: -1px;
            right: -1px;
        }
    }
}
</style>
